export const BRANDING_GET_DETAILS_REQUEST = "BRANDING_GET_DETAILS_REQUEST"
export const BRANDINGLIST_GET_DETAILS_SUCCESS = "BRANDINGLIST_GET_DETAILS_SUCCESS"
export const BRANDING_LIST_GET_DETAILS_FAIL = "BRANDING_LIST_GET_DETAILS_FAIL"
